<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="投稿管理" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
                            <FGCollapsiblePanel title="基本信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="投稿单编号">
                                            <a-input ref="djbh" v-model="editData.djbh" class="view" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="投稿类型" required>
                                            <FGDictSelectCN ref="tglx" dictNo="TG100201" v-model="editData.tglx" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12" v-if="editData.tglx === '主题征文'">
                                        <a-form-item label="主题名称">
                                            <a-input-search ref="ztmc" @search="isShow_zt = true" v-model="editData.ztmc" readOnly />
                                            <FGDataSelect :isShow.sync="isShow_zt" selectNo="TG1001" @saveselect="saveEvent_zt(arguments)"></FGDataSelect>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位名称">
                                            <a-input ref="dwmc" v-model="editData.dwmc" class="view" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位编号">
                                            <a-input ref="dwbh" v-model="editData.dwbh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="联系人">
                                            <a-input ref="lxr" v-model="editData.lxr" class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="联系方式">
                                            <a-input ref="lxfs" v-model="editData.lxfs" class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="QQ">
                                            <a-input ref="qq" v-model="editData.qq" class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="关键词" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
                                            <a-textarea ref="gjc" v-model="editData.gjc" :auto-size="{ minRows: 1, maxRows: 3 }" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="简介" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
                                            <a-textarea ref="jj" v-model="editData.jj" :auto-size="{ minRows: 5, maxRows: 10 }" />
                                        </a-form-item>
                                    </a-col>

                                    <a-col :span="24">
                                        <a-form-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
                                            <a-textarea ref="bz" v-model="editData.bz" :auto-size="{ minRows: 5, maxRows: 10 }" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                        </a-form>
                    </a-spin>
                    <!-- 流程跟踪组件 -->
                    <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachUpload ref="attachup" :isnew="editData.isnew" :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters, mapActions } = createNamespacedHelpers("user");
export default {
    name: "TgsqEdit",
    components: {},
    props: ["dataId", "submited", "componentName"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            //资质证书及服务范围
            isShow_zt: false,
            dwxxData: {},
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken", "getNoticeId"]),
        subTitle() {
            return this.editDataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.componentName;
            },
            set(newVal) {
                this.$emit("update:componentName", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        // 当前编辑记录id
        editSubmited: {
            get() {
                return this.submited;
            },
            set(newVal) {
                this.$emit("update:submited", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        //附件参数
        attachCfg() {
            return {
                fktable: "DW_TGSQ",
                fkfield: "ID",
                fkvalue: this.editData.id,
                attachsource: "TG1002"
            };
        }
    },
    activated() {
        let user = this.getUserInfo;
        if (!this.dataId) {
            this.loadDwxxData();
            this.$FG_helper.handleNewBillCode("TGSQ001").then((val) => {
                // 新增，设置默认值
                this.editData = {
                    id: this.$FG_util.uuid(),
                    isnew: true,
                    djzt: "制定",
                    djlxid: "TGSQB",
                    djbh: val,
                    lrr: user.personnel_name,
                    lrbmmc: user.org_name,
                    bmid: user.org_id,
                    ryid: user.personnel_id,
                    yhid: user.id,
                    lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
                    //根据当前用户单位信息设置默认值
                    dwid: this.dwxxData.id,
                    dwbh: this.dwxxData.dwbh,
                    dwmc: this.dwxxData.dwmc,
                    lxr: this.dwxxData.lxr,
                    lxfs: this.dwxxData.lxfs,
                    qq: this.dwxxData.qq,
                    tglx: "",
                    ztmc: ""
                };
                if (this.getNoticeId) {
                    this.editData.tglx = "主题征文";
                    this.$FG_http
                        .post(
                            "./api/main/zxdw/tggl/ztzwdy/getDetail",
                            {
                                id: this.getNoticeId
                            },
                            {
                                showSuccess: false
                            }
                        )
                        .then(({ success, data, errMsg }) => {
                            if (success && data.data) {
                                this.editData.ztid = data.data.id;
                                this.editData.ztmc = data.data.ztmc;
                                this.setNoticeId(null);
                            }
                        });
                }
            });
        } else {
            // 修改，加载数据
            this.loadData();
        }
    },
    methods: {
        ...mapActions(["setNoticeId"]),
        saveEvent_zt(val, currentrow) {
            if (val && val.length > 0) {
                let zt = val[0][0];
                this.editData.ztid = zt.ID;
                this.editData.ztmc = zt.ZTMC;
            }
        },
        //提交form
        onSave(btnType) {
            // 表单校验
            if (!this.editData.tglx) {
                this.$FG_message.error("P0001", "投稿类型").then(() => this.$refs.tglx.focus());
                return;
            } else if (this.editData.tglx === "主题征文" && !this.editData.ztmc) {
                this.$FG_message.error("P0001", "主题征文投稿的主题").then(() => this.$refs.ztmc.focus());
                return;
            }
            // 保存操作

            this.saving = true;
            this.editDataId = this.editData.id;
            this.$FG_http
                .post(
                    "./api/main/zxdw/tggl/tggl/save",
                    {
                        data: this.editData
                    },
                    {
                        showSuccess: btnType === 1 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                        if (btnType === 1) {
                            this.submit();
                        } else {
                            this.loadData();
                        }
                    }
                });
        },
        submit() {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/zxdw/tggl/tggl/submit", {
                            data: this.editData
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                //提交之后跳转主页面
                                this.editIsVisible = "TgsqBrowse";
                            } else {
                                this.$refs.tglx.focus();
                            }
                        });
                }
            });
        },
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxdw/tggl/tggl/getDetail",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = "TgsqBrowse"));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = "TgsqBrowse";
                    }
                });
        },
        loadDwxxData() {
            this.dwxxData = {};
            this.$FG_http
                .post(
                    "./api/main/zxdw/tggl/tggl/selectDwxx",
                    {},
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.dwxxData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = "TgsqBrowse"));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = "TgsqBrowse";
                    }
                });
        },
        // 返回列表
        onBack() {
            this.editIsVisible = "TgsqBrowse";
        },
        //加载操作日志
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
<style lang="scss" scoped>
.collapsible-panel-title {
    width: 100%;
    height: 20px;
    margin: 24px 0 0 0;
    display: flex;

    .collapsible-panel-title-txt {
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        color: #1e202d;
        border-left: 5px solid #33cde5;
        padding: 0 8px;
    }

    .collapsible-panel-title-content {
        font-size: 14px;
        height: 20px;
        color: #f77824fb;
        background-color: #f5ece4;
    }
}
</style>
